import { configureStore } from "@reduxjs/toolkit";
import ThemeSlice from "redux/common/themeSlice";
import autorizationSlice from "redux/common/autorizationSlice";
import AccountActivationSlice from "redux/common/AccountActivationSlice";

export const store = configureStore({
  reducer: {
    ThemeSlice,
    autorizationSlice,
    AccountActivationSlice
  },
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
